import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/push";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Capture the PWA install prompt as EARLY as possible. The browser fires
// `beforeinstallprompt` once on initial load and never replays it, so if we
// only listen inside a component that mounts later (e.g. Settings), the event
// is missed and the in-app "Install" button never appears. Stash it globally
// here and let usePWAInstall read it whenever it mounts.
window.__deferredInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event("pwa-install-available"));
});
window.addEventListener("appinstalled", () => {
  window.__deferredInstallPrompt = null;
});

// Register the service worker for PWA install + push notifications
registerServiceWorker();

// Auto-recover from stale caches after a redeploy: when a new service worker
// takes control (and one was already controlling), reload once to get fresh assets.
if ("serviceWorker" in navigator) {
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    if (hadController) window.location.reload();
  });
}
